module.exports = __webpack_public_path__ + "static/img/mp1.1a2d157.png";